export default {
  init() {
    // JavaScript to be fired on the home page

    const lang = $('html').attr('lang');

    $.getJSON('https://www.instagram.com/rollingmeadowdairy/?__a=1', function(data) {
      let count = 0;
      $.each(data.graphql.user.edge_owner_to_timeline_media.edges, function() {
        $('.instagram .row').append(`
          <a class="col-9 col-sm-6 col-md-3 mb-5 mb-md-2 border-0" target="_blank"
            href="https://www.instagram.com/p/${this.node.shortcode}/?hl=${lang}">
            <img src="${this.node.thumbnail_src}" class="img-fluid hover-grow" alt="">
          </a>
        `);
        if (++count === 6) {
          return false;
        }
      });
    });
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js